/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface Principal {
  insecure?: boolean;
}

export interface Error {
  /** @format int32 */
  code?: number;
  message: string;
  detailedMessage: string;
}

export interface KmsVersionResponse {
  Version: string;
  Commit: string;
}

export interface KmsAPIsResponse {
  APIs: KmsAPI[];
}

export interface KmsAPI {
  method?: string;
  path?: string;
  maxBody?: number;
  timeout?: number;
}

export interface KmsListPoliciesResponse {
  Names: string[];
  ContinueAt: string;
}

export interface KmsCreatePolicyRequest {
  allow?: object;
  deny?: object;
}

export interface KmsGetPolicyResponse {
  allow?: object;
  deny?: object;
  Name?: string;
  CreatedAt?: string;
  CreatedBy?: string;
}

export interface KmsListEnclavesResponse {
  Names: string[];
  ContinueAt: string;
}

export interface KmsDescribeEnclaveResponse {
  Name?: string;
  CreatedAt?: string;
  createdBy?: string;
}

export interface KmsListKeysResponse {
  Names: string[];
  ContinueAt: string;
}

export interface KmsDescribeKeyResponse {
  Name?: string;
  CreatedAt?: string;
  createdBy?: string;
}

export interface KmsCreateKeyRequest {
  Type?: string;
  AddVersion?: boolean;
}

export interface KmsListIdentitiesResponse {
  Names: string[];
  ContinueAt: string;
}

export interface KmsDescribeIdentityResponse {
  Name?: string;
  CreatedAt?: string;
  createdBy?: string;
}

export type KmsCreateIdentityRequest = object;

export interface KmsListClustersResponse {
  Names: string[];
  ContinueAt: string;
}

export interface KmsCreateClusterRequest {
  Type?: string;
  AddVersion?: boolean;
}

export interface KmsDescribeClusterResponse {
  Name?: string;
  CreatedAt?: string;
  createdBy?: string;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "/v1";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title MinIO KMS
 * @version 0.1.0
 * @baseUrl /v1
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  version = {
    /**
     * No description
     *
     * @tags kms
     * @name Version
     * @summary KMS Version
     * @request GET:/version/
     * @secure
     */
    version: (params: RequestParams = {}) =>
      this.request<KmsVersionResponse, Error>({
        path: `/version/`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  api = {
    /**
     * No description
     *
     * @tags kms
     * @name Api
     * @summary KMS Supported APIs
     * @request GET:/api
     * @secure
     */
    api: (params: RequestParams = {}) =>
      this.request<KmsAPIsResponse, Error>({
        path: `/api`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  policy = {
    /**
     * No description
     *
     * @tags kms
     * @name ListPolicies
     * @summary KMS list policies
     * @request GET:/policy/list/
     * @secure
     */
    listPolicies: (
      query?: {
        /** pattern to retrieve policies */
        pattern?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<KmsListPoliciesResponse, Error>({
        path: `/policy/list/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags kms
     * @name GetPolicy
     * @summary Get KMS Policy
     * @request GET:/policy/read/{name}
     * @secure
     */
    getPolicy: (name: string, params: RequestParams = {}) =>
      this.request<KmsGetPolicyResponse, Error>({
        path: `/policy/read/${name}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags kms
     * @name CreatePolicy
     * @summary Create KMS Policy
     * @request PUT:/policy/create/{name}
     * @secure
     */
    createPolicy: (
      name: string,
      body: KmsCreatePolicyRequest,
      params: RequestParams = {},
    ) =>
      this.request<any, void>({
        path: `/policy/create/${name}`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags kms
     * @name DeletePolicy
     * @summary Delete KMS Policy
     * @request DELETE:/policy/delete/{name}
     * @secure
     */
    deletePolicy: (name: string, params: RequestParams = {}) =>
      this.request<void, Error>({
        path: `/policy/delete/${name}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  enclave = {
    /**
     * No description
     *
     * @tags kms
     * @name ListEnclaves
     * @summary KMS list enclaves
     * @request GET:/enclave/list/
     * @secure
     */
    listEnclaves: (
      query?: {
        /** pattern to retrieve policies */
        pattern?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<KmsListEnclavesResponse, Error>({
        path: `/enclave/list/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags kms
     * @name CreateEnclave
     * @summary Create KMS Enclave
     * @request PUT:/enclave/create/{name}
     * @secure
     */
    createEnclave: (name: string, params: RequestParams = {}) =>
      this.request<void, Error>({
        path: `/enclave/create/${name}`,
        method: "PUT",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags kms
     * @name DeleteEnclave
     * @summary Delete KMS Enclave
     * @request PUT:/enclave/delete/{name}
     * @secure
     */
    deleteEnclave: (name: string, params: RequestParams = {}) =>
      this.request<void, Error>({
        path: `/enclave/delete/${name}`,
        method: "PUT",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags kms
     * @name DescribeEnclave
     * @summary Describe KMS Enclave
     * @request GET:/enclave/describe/{name}
     * @secure
     */
    describeEnclave: (name: string, params: RequestParams = {}) =>
      this.request<KmsDescribeEnclaveResponse, Error>({
        path: `/enclave/describe/${name}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  key = {
    /**
     * No description
     *
     * @tags kms
     * @name ListKeys
     * @summary KMS list keys
     * @request GET:/key/list/
     * @secure
     */
    listKeys: (
      query?: {
        /** pattern to retrieve policies */
        pattern?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<KmsListKeysResponse, Error>({
        path: `/key/list/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags kms
     * @name CreateKey
     * @summary Create KMS Key
     * @request PUT:/key/create/{name}
     * @secure
     */
    createKey: (
      name: string,
      body: KmsCreateKeyRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, Error>({
        path: `/key/create/${name}`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags kms
     * @name DeleteKey
     * @summary Delete KMS Key
     * @request DELETE:/key/delete/{name}
     * @secure
     */
    deleteKey: (name: string, params: RequestParams = {}) =>
      this.request<void, Error>({
        path: `/key/delete/${name}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags kms
     * @name DescribeKey
     * @summary Describe KMS Key
     * @request GET:/key/describe/{name}
     * @secure
     */
    describeKey: (name: string, params: RequestParams = {}) =>
      this.request<KmsDescribeKeyResponse, Error>({
        path: `/key/describe/${name}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  identity = {
    /**
     * No description
     *
     * @tags kms
     * @name ListIdentities
     * @summary KMS list Identities
     * @request GET:/identity/list/
     * @secure
     */
    listIdentities: (
      query?: {
        /** pattern to retrieve identities */
        pattern?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, Error>({
        path: `/identity/list/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags kms
     * @name CreateIdentity
     * @summary Create KMS Identity
     * @request PUT:/identity/create/{name}
     * @secure
     */
    createIdentity: (
      name: string,
      body: KmsCreateIdentityRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, Error>({
        path: `/identity/create/${name}`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags kms
     * @name DeleteIdentity
     * @summary Delete KMS Identity
     * @request DELETE:/identity/delete/{name}
     * @secure
     */
    deleteIdentity: (name: string, params: RequestParams = {}) =>
      this.request<void, Error>({
        path: `/identity/delete/${name}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags kms
     * @name DescribeIdentity
     * @summary Describe KMS Identity
     * @request GET:/identity/describe/{name}
     * @secure
     */
    describeIdentity: (name: string, params: RequestParams = {}) =>
      this.request<KmsDescribeIdentityResponse, Error>({
        path: `/identity/describe/${name}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  cluster = {
    /**
     * No description
     *
     * @tags kms
     * @name ListClusters
     * @summary KMS list clusters
     * @request GET:/cluster/list/
     * @secure
     */
    listClusters: (
      query?: {
        /** pattern to retrieve policies */
        pattern?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<KmsListClustersResponse, Error>({
        path: `/cluster/list/`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags kms
     * @name CreateCluster
     * @summary Create KMS Cluster
     * @request PUT:/cluster/create/{name}
     * @secure
     */
    createCluster: (
      name: string,
      body: KmsCreateClusterRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, Error>({
        path: `/cluster/create/${name}`,
        method: "PUT",
        body: body,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags kms
     * @name DeleteCluster
     * @summary Delete KMS Cluster
     * @request DELETE:/cluster/delete/{name}
     * @secure
     */
    deleteCluster: (name: string, params: RequestParams = {}) =>
      this.request<void, Error>({
        path: `/cluster/delete/${name}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags kms
     * @name DescribeCluster
     * @summary Describe KMS Cluster
     * @request GET:/cluster/describe/{name}
     * @secure
     */
    describeCluster: (name: string, params: RequestParams = {}) =>
      this.request<KmsDescribeClusterResponse, Error>({
        path: `/cluster/describe/${name}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
